import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { EnvironmentConfiguration } from '@models/environment-model';
import { HttpBackend, HttpClient } from '@angular/common/http';

@Injectable()

export class ConfigurationService {

  private _objectoConfiguracionAplicacion: EnvironmentConfiguration;
  private httpClient: HttpClient;

  constructor(httpBackend: HttpBackend) {
    this.httpClient = new HttpClient(httpBackend);
    this.load();
  }

  load() {
    this._objectoConfiguracionAplicacion = environment;

    this.httpClient.get("config.json").subscribe(config => {
      Object.keys(config).forEach(element => {
        this._objectoConfiguracionAplicacion[element] = config[element];
      });
    });
  }

  fetchConfiguration(config: any) {
    Object.keys(config).forEach(element => {
      this._objectoConfiguracionAplicacion[element] = config[element];
    });
  }

  get configuration() {
    return this._objectoConfiguracionAplicacion;
  }

  get exceptionRadios() {
    return this._objectoConfiguracionAplicacion.ExceptionRadios;
  }
}